/**
 * add-to-cart-feedback.js
 * The product form posts natively to /cart/add and the browser then loads
 * /cart. That round trip takes a moment on mobile, and the button previously
 * gave no sign that anything had happened. This gives it an immediate visible
 * state and stops a second tap firing a second add.
 *
 * Vignovic Agency - Sock Candy (EO-029)
 */
(function () {
  'use strict';

  var BUSY = 'data-vgn-submitting';

  function restore(form) {
    form.removeAttribute(BUSY);
    var button = form.querySelector('[data-submit-button]');
    if (!button) return;
    button.removeAttribute('aria-busy');
    button.style.opacity = '';
    var label = button.querySelector('[data-submit-button-text]');
    if (label && button.getAttribute('data-vgn-label')) {
      label.textContent = button.getAttribute('data-vgn-label');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[data-product-form]')) return;

    if (form.hasAttribute(BUSY)) {
      event.preventDefault();
      return;
    }
    form.setAttribute(BUSY, 'true');

    var button = form.querySelector('[data-submit-button]');
    if (!button) return;

    var label = button.querySelector('[data-submit-button-text]');
    if (label) {
      button.setAttribute('data-vgn-label', label.textContent.trim());
      label.textContent = 'Adding to cart...';
    }
    button.setAttribute('aria-busy', 'true');
    button.style.opacity = '0.65';
  }, true);

  window.addEventListener('pageshow', function () {
    var forms = document.querySelectorAll('form[data-product-form][' + BUSY + ']');
    for (var i = 0; i < forms.length; i++) restore(forms[i]);
  });
})();